module.exports = __webpack_public_path__ + "static/img/coupons-40-check.96273d21.png";